import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../../../config/config.js";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import { toast } from "react-hot-toast";
import Select from "react-select";
import { useParams } from "react-router-dom";
import { useSisdeuImportStatus } from "../../../hooks/useSisdeuImportStatus.js";

const ModalConfigPrimeraFase = ({ open, setOpen, tipoFase }) => {
  const [inputValue, setInputValue] = useState("");
  const [institutions, setInstitutions] = useState([]);
  const [selectedInstitution, setSelectedInstitution] = useState(null); // Para el select
  const [loading, setLoading] = useState(false);
  const { idevent, idsport } = useParams();
  // FTR-0048: con la importación SISDEU nueva activa para el evento (company 1) se oculta el alta legacy por SISDEU.
  // Mientras se consulta no se muestra (sin parpadeo); un error del estado vuelve a mostrarla, como siempre.
  const { loading: sisdeuImportLoading, status: sisdeuImportStatus } = useSisdeuImportStatus({ idevent, idsport, enabled: Boolean(open) });
  const showLegacySisdeu = !sisdeuImportLoading && !sisdeuImportStatus.integrationActive;

  useEffect(() => {
    const getInstitutions = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/institutions`);
        setInstitutions(
          response.data.map((inst) => ({
            value: inst.idinstitution,
            label: `${inst.abrev} - ${inst.name}`,
          }))
        );
      } catch (error) {
        console.error("Error al traer instituciones", error);
      }
    };

    getInstitutions();
  }, []);

  const handleAddInstitutionManualmente = async () => {
    try {
      await axios.post(`${API_BASE_URL}/participant`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
        // idtypephase: Number(tipoFase),
        idtypephase: 1,
        idinstitution: Number(inputValue),
      });
      toast.success("¡Institución Añadida Correctamente!");
    } catch (error) {
      toast.error("¡Hubo un Problema al Intentar Añadir una Institución!");
      console.error("Error enviando el participante manualmente", error);
    }
  };

  const handleAddInstitutionFromSelect = async () => {
    if (!selectedInstitution) {
      toast.error("Por favor, selecciona una institución.");
      return;
    }
    try {
      await axios.post(`${API_BASE_URL}/participant`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
        // idtypephase: Number(tipoFase),
        idtypephase: 1,
        idinstitution: selectedInstitution.value,
      });
      toast.success("¡Institución Añadida Correctamente desde la lista!");
    } catch (error) {
      toast.error("¡Hubo un Problema al Intentar Añadir la Institución!");
      console.error("Error añadiendo institución desde la lista", error);
    }
  };

  const handleUpdateInstitucionesParticipantes = async () => {
    setLoading(true);
    try {
      // 1. Obtener la lista de instituciones
      const response = await axios.post(
        "https://sismaster.perufedup.com/public/events/institutions",
        {
          idevent: Number(idevent),
          idsport: Number(idsport),
        },
        { withCredentials: false }
      );

      // console.log("Instituciones recibidas:", response.data);

      // 2. Construir el array para /participantes
      const participantesData = response.data.map((inst) => ({
        idevent: Number(idevent),
        idsport: Number(idsport),
        // idtypephase: Number(tipoFase),
        idtypephase: 1,
        idinstitution: Number(inst.idinstitution),
      }));

      // 3. Enviar ese array al endpoint /participantes
      const res2 = await axios.post(
        `${API_BASE_URL}/participantes`,
        participantesData
      );

      console.log("Participantes creados:", res2.data);
      toast.success("¡Instituciones y participantes guardados correctamente!");
    } catch (error) {
      toast.error("¡Hubo un problema al procesar los participantes!");
      console.error("Error al crear participantes:", error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={open}
        onClose={() => setOpen(false)}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{
            maxWidth: 600,
            width: "100%",
            borderRadius: "md",
            p: 4,
            boxShadow: "lg",
            background: "#f9f9f9",
          }}
        >
          <ModalClose variant="plain" sx={{ m: 1 }} />
          <Typography
            component="h2"
            id="modal-title"
            level="h4"
            fontWeight="bold"
            sx={{ color: "#333", mb: 3 }}
          >
            Configuración de Instituciones
          </Typography>

          {showLegacySisdeu && (<>
          {/* Sección 1: Agregar instituciones participantes por SISDEU */}
          <div className="mb-6">
            <Typography
              id="modal-subtitle"
              sx={{ color: "#555", fontWeight: "medium", mb: 1 }}
              disabled={loading}
            >
              Agregar Instituciones Participantes por SISDEU
            </Typography>
            <button
              className={`w-full py-2 px-4 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300
        ${loading
                  ? "bg-blue-400 cursor-not-allowed"   // estilo cuando está cargando
                  : "bg-blue-600 hover:bg-blue-700"     // estilo normal
                }`}
              onClick={handleUpdateInstitucionesParticipantes}
              disabled={loading}
            >
              {loading ? (
                <span className="flex items-center justify-center">
                  {/* Ícono SVG de spinner (Tailwind + animate-spin) */}
                  <svg
                    className="animate-spin h-5 w-5 mr-2 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                    ></path>
                  </svg>
                  Cargando...
                </span>
              ) : (
                "Actualizar Instituciones Participantes"
              )}
            </button>
          </div>
          <hr className="my-4 border-gray-300" />
          </>)}

          {/* Sección 2: Añadir institución desde la lista */}
          <div className="mb-6">
            <Typography
              id="modal-subtitle-list"
              sx={{ color: "#555", fontWeight: "medium", mb: 1 }}
            >
              Añadir Institución desde la Lista
            </Typography>
            <Select
              options={institutions}
              value={selectedInstitution}
              onChange={(option) => setSelectedInstitution(option)}
              placeholder="Selecciona una institución"
              isSearchable
              className="mb-4"
            />
            <button
              className="w-full py-2 px-4 text-white bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-300"
              onClick={handleAddInstitutionFromSelect}
            >
              Añadir Institución
            </button>
          </div>
          <hr className="my-4 border-gray-300" />

          {/* Sección 3: Añadir institución manualmente */}
          <div>
            <Typography
              id="modal-subtitle-manual"
              sx={{ color: "#555", fontWeight: "medium", mb: 1 }}
            >
              Añadir Institución Manualmente
            </Typography>
            <div className="flex items-center space-x-2">
              <input
                type="text"
                className="flex-grow p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300"
                placeholder="ID de la Institución"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
              <button
                className="px-4 py-2 text-white bg-orange-600 rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-300"
                onClick={handleAddInstitutionManualmente}
              >
                Añadir
              </button>
            </div>
          </div>
        </Sheet>
      </Modal>
    </>
  );
};

export default ModalConfigPrimeraFase;
